(function () {
  function closestElement(element, selector) {
    if (!element) return null;
    if (element.closest) return element.closest(selector);

    while (element && element.nodeType === 1) {
      if (element.matches && element.matches(selector)) return element;
      element = element.parentElement;
    }

    return null;
  }

  function setPanelVisibility(root, activePanel) {
    var panels = root.querySelectorAll('.mdm-panel');

    Array.prototype.forEach.call(panels, function (panel) {
      var isActive = panel === activePanel;
      panel.classList.toggle('is-active', isActive);
      panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });
  }

  function resetPanels(root) {
    if (!root) return;

    var firstPanel = root.querySelector('[data-panel="0"]');
    if (!firstPanel) return;

    setPanelVisibility(root, firstPanel);
    firstPanel.classList.remove('is-prev');

    var scrollArea = root.querySelector('[data-mdm-scroll]');
    if (scrollArea) scrollArea.scrollTop = 0;
  }

  function showPanel(root, targetId, direction) {
    var current = root.querySelector('.mdm-panel.is-active');
    var target = root.querySelector('[data-panel="' + targetId + '"]');

    if (!current || !target || current === target) return;

    current.classList.toggle('is-prev', direction === 'forward');
    target.classList.toggle('is-prev', direction === 'back');

    setPanelVisibility(root, target);

    window.setTimeout(function () {
      target.classList.remove('is-prev');
    }, 220);

    var scrollArea = root.querySelector('[data-mdm-scroll]');
    if (scrollArea) scrollArea.scrollTop = 0;
  }

  function initMobileDrawerMenu() {
    var root = document.getElementById('mdm-root');
    if (!root || root.getAttribute('data-mdm-ready') === 'true') return;

    root.setAttribute('data-mdm-ready', 'true');
    resetPanels(root);

    root.addEventListener('click', function (event) {
      var drillButton = closestElement(event.target, '.mdm-drill-btn');
      var backButton = closestElement(event.target, '.mdm-back-btn');

      if (drillButton) {
        var targetId = drillButton.getAttribute('data-target');
        if (targetId) showPanel(root, targetId, 'forward');
        return;
      }

      if (backButton) {
        var backId = backButton.getAttribute('data-back');
        if (backId) showPanel(root, backId, 'back');
      }
    });

    document.addEventListener('click', function (event) {
      var trigger = closestElement(event.target, '[data-drawer-open], .header__menu-toggle, .js-drawer-open');
      if (!trigger) return;

      window.setTimeout(function () {
        resetPanels(root);
      }, 80);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileDrawerMenu);
  } else {
    initMobileDrawerMenu();
  }
})();
